tag app-snackbar
	# css pos:fixed b:0 l:0 w:100% p:4 ta:center bg:red5 c:white

	css pos:fixed b:0 l:0 w:100% p:5 ta:center bg:green6/85 c:white y:100%
		tween:styles 0.5s quart-out zi:1300
		fs:lg
		&.danger bg:red6/85 
		&.info bg:yellow5/95 
		&.show y:0%

	def mount
		await imba.commit!
		flags.add('show')
		setTimeout(&,data.timeout or 4000) do
			flags.remove('show')
			setTimeout(&,500) do parentNode.removeChild(self)

	def render
		<self .code-{data.code or 200} .danger=(data.code >= 400)>
			if data.url
				<.message>
					<a[c:white td:underline]=(data.code >= 400) href=data.url target="_blank"> data.message
			else
				<.message> data.message
